module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-9",
    domProps: {
      "innerHTML": _vm._s(_vm.help_text)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d1dc0f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/help_text_display.vue
// module id = 947
// module chunks = 0